export const showCoverageAmountForBenefit = (benefit) => {
  return ["020", "021", "022", "070", "080", "081", "130", "143"].includes(
    benefit
  );
};
